/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  static escapeHTML(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  constructor() {
    this.container = document.getElementById("Search-Drawer");
    this.form = this.container.querySelector("form.searchform");
    this.button = document.querySelectorAll(".thb-quick-search");
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector(
      ".side-panel-content--initial",
    );
    this.predictiveSearchResults = this.container.querySelector(
      ".side-panel-content--has-tabs",
    );
    this.RECENT_SEARCHES_KEY = "loewi_recent_searches";

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    this.input.addEventListener("focus", () => {
      if (!this.getQuery().length) {
        this.showSuggestions();
      }
    });

    this.button.forEach((item, i) => {
      item.addEventListener("click", (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle("open-cc");
        this.container.classList.toggle("active");
        if (this.container.classList.contains("active")) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true,
            });
          }, 100);
          dispatchCustomEvent("search:open");
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove("active");
      this.showSuggestions();
      return;
    }
    this.predictiveSearchResults.classList.add("active");
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    } else {
      this.saveRecentSearch(this.getQuery());
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.showSuggestions();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getRecentSearches() {
    try {
      const searches = localStorage.getItem(this.RECENT_SEARCHES_KEY);
      return searches ? JSON.parse(searches) : [];
    } catch (e) {
      return [];
    }
  }

  saveRecentSearch(query) {
    try {
      let searches = this.getRecentSearches();
      searches = searches.filter(
        (s) => s.toLowerCase() !== query.toLowerCase(),
      );
      searches.unshift(query);
      searches = searches.slice(0, 3);
      localStorage.setItem(this.RECENT_SEARCHES_KEY, JSON.stringify(searches));
    } catch (e) {
      console.error("Error saving search:", e);
    }
  }

  showSuggestions() {
    // Les recherches récentes viennent de la saisie utilisateur (localStorage) :
    // on les échappe avant de les injecter dans le HTML.
    const recentSearches = this.getRecentSearches()
      .filter((search) => typeof search === "string")
      .map(PredictiveSearch.escapeHTML);
    let suggestionsHTML = '<div class="search-suggestions">';

    if (recentSearches.length > 0) {
      suggestionsHTML += `
        <div class="search-suggestions-section">
          <span class="search-suggestions-title">Recherches récentes</span>
          <ul class="search-suggestions-list">
            ${recentSearches
              .map(
                (search) => `
              <li class="search-suggestion-item" data-search="${search}">
                <span class="search-suggestion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </span>
                <span class="search-suggestion-text">${search}</span>
              </li>
            `,
              )
              .join("")}
          </ul>
        </div>
      `;
    }

    suggestionsHTML += `
      <div class="search-suggestions-section">
        <span class="search-suggestions-title">Top catégories</span>
        <ul class="search-suggestions-list">
          <li class="search-suggestion-item" data-url="/collections/vtc-electriques-reconditionnes">
            <span class="search-suggestion-text">VTC électrique</span>
          </li>
          <li class="search-suggestion-item" data-url="/collections/velos-de-ville-reconditionnes">
            <span class="search-suggestion-text">Vélo de ville électrique</span>
          </li>
          <li class="search-suggestion-item" data-url="/collections/velos-cargos-electriques-reconditionnes">
            <span class="search-suggestion-text">Vélo cargo électrique</span>
          </li>
        </ul>
      </div>
      <div class="search-suggestions-section">
        <span class="search-suggestions-title">Nos top marques</span>
        <ul class="search-suggestions-list">
          <li class="search-suggestion-item" data-url="/collections/moustache">
            <span class="search-suggestion-text">Vélo électrique Moustache</span>
          </li>
          <li class="search-suggestion-item" data-url="/collections/cube">
            <span class="search-suggestion-text">Vélo électrique Cube</span>
          </li>
          <li class="search-suggestion-item" data-url="/collections/btwin">
            <span class="search-suggestion-text">Vélo électrique Btwin</span>
          </li>
          <li class="search-suggestion-item" data-url="/collections/velo-electrique-nakamura">
            <span class="search-suggestion-text">Vélo électrique Nakamura</span>
          </li>
          <li class="search-suggestion-item" data-url="/collections/velo-electrique-tern">
            <span class="search-suggestion-text">Vélo électrique Tern</span>
          </li>
        </ul>
      </div>
    `;

    suggestionsHTML += "</div>";

    this.defaultTab.innerHTML = suggestionsHTML;
    this.defaultTab.classList.add("active");

    const _this = this;
    this.defaultTab
      .querySelectorAll(".search-suggestion-item")
      .forEach((item) => {
        item.addEventListener("click", function () {
          const searchTerm = this.getAttribute("data-search");
          const url = this.getAttribute("data-url");

          if (searchTerm) {
            _this.input.value = searchTerm;
            _this.saveRecentSearch(searchTerm);
            _this.form.submit();
          } else if (url) {
            window.location.href = url;
          }
        });
      });
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add("loading");

    fetch(
      `${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product,article,query&${encodeURIComponent("resources[limit]")}=10&section_id=predictive-search`,
    )
      .then((response) => {
        this.predictiveSearchResults.classList.remove("loading");
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.defaultTab.classList.remove("active");

    let _this = this,
      submitButton = this.container.querySelector("#search-results-submit");

    submitButton.addEventListener("click", () => {
      _this.saveRecentSearch(_this.getQuery());
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove("active");
  }
}
window.addEventListener("load", () => {
  if (typeof PredictiveSearch !== "undefined") {
    new PredictiveSearch();
  }
});
